class FooterAccordion extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    // Newsletter and non-accordion footer blocks use the same custom element
    // without <details>/<summary>. Leave those blocks intact instead of throwing.
    if (!this.detailsContainer || !this.summaryToggle) return;

    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length === 0;
    this.detailsContainer.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.close();
    });
    this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this));
    document.addEventListener("matchSmall", this.close.bind(this));
    document.addEventListener("unmatchSmall", this.open.bind(this));

    if (!theme.config.mqlSmall || this.summaryIsEmpty) {
      this.detailsContainer.setAttribute("open", true);
      if (this.summaryIsEmpty) this.detailsContainer.setAttribute("empty", true);
    } else if (this.dataset.open == null) {
      this.detailsContainer.removeAttribute("open");
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (event.target.closest("details").hasAttribute("open")) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (this.detailsContainer) this.detailsContainer.setAttribute("open", true);
  }

  close() {
    if (this.detailsContainer && theme.config.mqlSmall && !this.summaryIsEmpty) {
      this.detailsContainer.removeAttribute("open");
    }
  }
}

if (!customElements.get("footer-accordion")) {
  customElements.define("footer-accordion", FooterAccordion);
}
